const mixin = {
    data () {
      return {
      }
    }
  }
  
  export default (tmp) => {
    Object.assign(mixin, {
      data () {
        return {
          ...tmp
        }
      }
    })
    return mixin
  }